import { IDiameterklass } from "../../models/IProduktdefinition";
import { RadprisJustering } from "./RadprisJustering";

export class Diameterklass {
    startdiameter: number;
    radpris?: number;
    radprisDirty = false;
    radprisJustering: RadprisJustering[];
    dirty = false;
    constructor(model: IDiameterklass, setDirty = false) {
        this.startdiameter = model.startdiameter;
        this.radpris = model.radpris;
        this.radprisJustering = model.radprisJustering.map(x => new RadprisJustering(x));
        if (setDirty) {
            this.radprisDirty = true;
            this.dirty = true;
        }
    }
}
